(() => {
  'use strict';

  const SH = window.SassyHive;
  if (!SH) return;

  const colors = [
    ['Pink', '#f58da0'], ['Purple', '#9b76ca'], ['Blue', '#6fa7d8'],
    ['Green', '#7ea779'], ['Red', '#d95757'], ['Orange', '#e99a4a'],
    ['Yellow', '#efcf56'], ['Black', '#25211f'], ['White', '#fff'],
    ['Gold', '#d9a13c'], ['Silver', '#b8bcc3'], ['Neutrals', '#c5aa93'],
    ['Rainbow', 'linear-gradient(90deg,#f77,#fc7,#fd7,#7c8,#79f,#a7e)'],
    ['Surprise Me', '#ffd9df']
  ];

  const value = (id) => document.getElementById(id)?.value?.trim() || '';
  const selectedRadio = (name) => document.querySelector(`input[name="${name}"]:checked`)?.value || '';
  const checkedValues = (name) => [...document.querySelectorAll(`input[name="${name}"]:checked`)].map((input) => input.value);
  const mysteryCharmCount = (properties) => Number(
    properties?.['Mystery Charms'] || properties?.['Mystery Capsules']
  );

  const setTier = (tierNumber) => {
    const tier = SH.tiers.find((candidate) => candidate.balls === Number(tierNumber));
    const resolved = tier ? SH.resolveTier(tier.balls) : null;
    const variantId = SH.normalizeVariantId(resolved?.variantId);
    if (!tier || !resolved || !variantId || resolved.available === false) return false;
    SH.state.selectedTier = {
      ...tier,
      variantId,
      variantTitle: resolved.title || `${tier.balls} Mystery Charms`,
      available: true,
      price: Number.isFinite(Number(resolved.priceCents)) ? Number(resolved.priceCents) / 100 : tier.price
    };
    syncTier();
    return true;
  };

  const syncTier = () => {
    const tier = SH.state.selectedTier;
    const label = document.getElementById('selectedTierLabel');
    const honey = document.getElementById('selectedHoneyLabel');
    if (label) label.textContent = `${tier.balls} Mystery Charms — ${SH.formatMoney(tier.price)}`;
    if (honey) honey.textContent = `${tier.honey} Honey Drop${tier.honey > 1 ? 's' : ''}`;
  };

  const renderColors = () => {
    const node = document.getElementById('colorChoices');
    if (!node) return;
    node.innerHTML = colors.map(([name, background], index) =>
      `<div class="choice"><input type="checkbox" name="colors" id="color${index}" value="${SH.escapeHtml(name)}">
        <label for="color${index}"><span class="swatch" style="background:${background}"></span>${SH.escapeHtml(name)}</label></div>`
    ).join('');
  };

  const saveDraft = () => {
    const form = document.getElementById('quizForm');
    if (!form) return;
    try {
      const fields = {};
      form.querySelectorAll('input,textarea,select').forEach((control) => {
        if (!control.id) return;
        fields[control.id] = control.type === 'radio' || control.type === 'checkbox'
          ? { checked: control.checked }
          : { value: control.value };
      });
      sessionStorage.setItem(SH.keys.draft, JSON.stringify({
        selectedTierBalls: SH.state.selectedTier.balls,
        currentStep: SH.state.currentStep,
        fields
      }));
    } catch (error) {
      console.warn('The quiz draft could not be saved.', error);
    }
  };

  const clearDraft = () => {
    try { sessionStorage.removeItem(SH.keys.draft); } catch (_) {}
  };

  const restoreDraft = () => {
    if (!document.getElementById('quizForm') || SH.state.activeEdit) return;
    try {
      const raw = sessionStorage.getItem(SH.keys.draft);
      if (!raw) return;
      const draft = JSON.parse(raw);
      setTier(Number(draft.selectedTierBalls) || 15);
      Object.entries(draft.fields || {}).forEach(([id, state]) => {
        const control = document.getElementById(id);
        if (!control) return;
        if (control.type === 'radio' || control.type === 'checkbox') control.checked = Boolean(state.checked);
        else if (state.value !== undefined) control.value = String(state.value);
      });
      SH.state.currentStep = Math.max(1, Math.min(10, Number(draft.currentStep) || 1));
    } catch (error) {
      console.warn('The saved quiz draft could not be restored.', error);
      clearDraft();
    }
  };

  const updateVideoIdentification = () => {
    const nickname = document.getElementById('videoName')?.value === 'nickname';
    const field = document.getElementById('videoNicknameField');
    const input = document.getElementById('videoNickname');
    if (field) field.hidden = !nickname;
    if (input) {
      input.disabled = !nickname;
      input.required = nickname;
    }
  };

  const updateVideo = () => {
    const selected = document.getElementById('videoYes')?.checked === true;
    const details = document.getElementById('videoDetails');
    const consent = document.getElementById('videoConsent');
    if (details) details.style.display = selected ? 'block' : 'none';
    if (consent) consent.required = selected;
    updateVideoIdentification();
  };

  const updateRepeat = () => {
    const returning = document.getElementById('repeatYes')?.checked === true;
    const field = document.getElementById('previousOrderField');
    const input = document.getElementById('previousOrderNumber');
    if (field) field.hidden = !returning;
    if (input) input.disabled = !returning;
  };

  const videoIdentification = () => {
    const choice = document.getElementById('videoName')?.value || 'customer';
    if (choice === 'recipient') return value('recipientName') || value('customerName') || 'Sassy Hive Customer';
    if (choice === 'nickname') return value('videoNickname');
    if (choice === 'anonymous') return 'A Sassy Hive Customer';
    return value('customerName') || 'Sassy Hive Customer';
  };

  const renderReview = () => {
    const video = document.getElementById('videoYes')?.checked === true;
    const tier = SH.state.selectedTier;
    const extras = SH.quiz.extraItems();
    const total = tier.price + (video ? SH.featureVideoPrice : 0) + extras.reduce((sum, item) => sum + item.quantity * item.price, 0);
    const name = value('recipientName') || value('customerName') || 'Not provided';
    const favoriteColors = checkedValues('colors');
    const review = document.getElementById('reviewBox');
    if (!review) return;
    review.innerHTML = `<div class="summary-card">
      <div class="summary-row"><span>Selected tier</span><strong>${tier.balls} Mystery Charms</strong></div>
      <div class="summary-row"><span>Guaranteed Honey Drops</span><strong>${tier.honey}</strong></div>
      <div class="summary-row"><span>Base price</span><strong>${SH.formatMoney(tier.price)}</strong></div>
      <div class="summary-row"><span>Feature Video</span><strong>${video ? `Yes — ${SH.formatMoney(SH.featureVideoPrice)}` : 'No'}</strong></div>
      ${video ? `<div class="summary-row"><span>Name used in video</span><strong>${SH.escapeHtml(videoIdentification())}</strong></div>` : ''}
      ${extras.map(item => `<div class="summary-row"><span>${SH.escapeHtml(item.label)} × ${item.quantity}</span><strong>${SH.formatMoney(item.quantity * item.price)}</strong></div>`).join('')}
      <div class="summary-row total"><span>Total</span><strong>${SH.formatMoney(total)}</strong></div>
    </div>
    <div class="summary-card">
      <h3 class="serif" style="margin-top:0">Hive Profile for ${SH.escapeHtml(name)}</h3>
      <p><strong>Sassiness and/or sarcasm:</strong> ${SH.escapeHtml(selectedRadio('sass') || 'Not selected')}</p>
      <p><strong>Favorite colors:</strong> ${favoriteColors.length ? favoriteColors.map(SH.escapeHtml).join(', ') : 'Surprise me'}</p>
      ${value('avoidColors') ? `<p><strong>Colors to avoid, if possible:</strong> ${SH.escapeHtml(value('avoidColors'))}</p>` : ''}
      ${value('hopeItems') ? `<p><strong>Fun items hoped for:</strong> ${SH.escapeHtml(value('hopeItems'))}</p>` : ''}
      ${value('spoilItems') ? `<p><strong>Items preferred not to receive:</strong> ${SH.escapeHtml(value('spoilItems'))}</p>` : ''}
      ${value('mustNotInclude') ? `<p><strong>Must not include:</strong> ${SH.escapeHtml(value('mustNotInclude'))}</p>` : ''}
      <p><strong>Gold or silver preference:</strong> ${SH.escapeHtml(selectedRadio('metalPreference') || 'Surprise me')}</p>
      ${value('aboutYouNotes') ? `<p><strong>About you:</strong> ${SH.escapeHtml(value('aboutYouNotes'))}</p>` : ''}
      <p><strong>Previous customer:</strong> ${SH.escapeHtml(selectedRadio('repeatCustomer') || 'No, this is my first order')}</p>
      ${value('previousOrderNumber') ? `<p><strong>Previous order number:</strong> ${SH.escapeHtml(value('previousOrderNumber'))}</p>` : ''}
    </div>`;
  };

  const updateQuiz = () => {
    const shell = document.querySelector('.quiz-shell');
    const progress = document.getElementById('quizProgress');
    const back = document.getElementById('backBtn');
    const next = document.getElementById('nextBtn');
    if (!shell || !progress || !back || !next) return;
    document.querySelectorAll('.quiz-step').forEach((step) => {
      const active = Number(step.dataset.step) === SH.state.currentStep;
      step.classList.toggle('active', active);
      step.setAttribute('aria-hidden', String(!active));
    });
    progress.style.width = `${SH.state.currentStep / 10 * 100}%`;
    progress.parentElement?.setAttribute('aria-valuenow', String(SH.state.currentStep));
    back.style.visibility = SH.state.currentStep === 1 ? 'hidden' : 'visible';
    next.style.display = SH.state.currentStep === 10 ? 'none' : 'inline-flex';
    if (SH.state.currentStep === 10) renderReview();
    saveDraft();
    window.scrollTo({ top: Math.max(0, shell.offsetTop - 110), behavior: SH.prefersReducedMotion() ? 'auto' : 'smooth' });
    window.setTimeout(() => {
      document.querySelector(`.quiz-step[data-step="${SH.state.currentStep}"] h2`)?.focus({ preventScroll: true });
    }, SH.prefersReducedMotion() ? 0 : 220);
  };

  const move = (delta) => {
    if (delta > 0 && SH.state.currentStep === 1 && !value('customerName')) {
      SH.toast('Please enter a first name before continuing.');
      document.getElementById('customerName')?.focus();
      return;
    }
    if (delta > 0 && SH.state.currentStep === 8 && document.getElementById('videoYes')?.checked) {
      if (document.getElementById('videoName')?.value === 'nickname' && !value('videoNickname')) {
        SH.toast('Please enter the nickname you want us to use in the Feature Video.');
        document.getElementById('videoNickname')?.focus();
        return;
      }
      if (!document.getElementById('videoConsent')?.checked) {
        SH.toast('Please confirm video consent before continuing.');
        document.getElementById('videoConsent')?.focus();
        return;
      }
    }
    SH.state.currentStep = Math.max(1, Math.min(10, SH.state.currentStep + delta));
    updateQuiz();
  };

  const start = (tierNumber) => {
    const requested = Number(tierNumber);
    if (SH.state.activeEdit && requested !== mysteryCharmCount(SH.state.activeEdit.properties)) {
      SH.toast('Finish or cancel this edit before choosing a different Mystery Box tier.');
      window.location.hash = 'customize';
      return;
    }
    if (!setTier(requested)) {
      SH.toast(`The ${requested}-charm tier is currently unavailable.`);
      return;
    }
    SH.state.currentStep = 1;
    saveDraft();
    window.location.hash = 'customize';
    updateQuiz();
  };

  const applyRadio = (name, stored) => {
    if (!stored) return;
    const match = [...document.querySelectorAll(`input[name="${name}"]`)].find((input) => input.value === stored);
    if (match) match.checked = true;
  };

  const applyColors = (stored) => {
    const chosen = String(stored || '').split(',').map((item) => item.trim()).filter(Boolean);
    document.querySelectorAll('input[name="colors"]').forEach((input) => { input.checked = chosen.includes(input.value); });
  };

  const inferVideoChoice = (properties) => {
    const explicit = properties['Video Identification Choice'];
    if (['customer', 'recipient', 'nickname', 'anonymous'].includes(explicit)) return explicit;
    const identification = properties['Video Identification'] || '';
    if (identification === 'A Sassy Hive Customer') return 'anonymous';
    if (identification && identification === properties['Recipient Name']) return 'recipient';
    if (identification && identification === properties['Customer Name']) return 'customer';
    return identification ? 'nickname' : 'customer';
  };

  const restoreFromProperties = (payload) => {
    (SH.config.addons || []).forEach(addon => {
      const input = document.getElementById(addon.key);
      if (input) input.value = String((payload.addons || []).filter(line => String(line.variantId) === String(addon.variantId)).reduce((sum, line) => sum + line.quantity, 0));
    });
    const properties = payload.properties || {};
    const tierNumber = mysteryCharmCount(properties);
    const tier = SH.tiers.find((item) => item.balls === tierNumber);
    if (!tier) return false;
    const resolved = SH.resolveTier(tierNumber);
    SH.state.activeEdit = payload;
    SH.state.selectedTier = {
      ...tier,
      variantId: SH.normalizeVariantId(payload.mysteryVariantId || resolved?.variantId),
      variantTitle: resolved?.title || `${tierNumber} Mystery Charms`,
      available: true,
      price: Number.isFinite(Number(resolved?.priceCents)) ? Number(resolved.priceCents) / 100 : tier.price
    };
    applyRadio('forWho', properties['Box For']);
    document.getElementById('customerName').value = properties['Customer Name'] || '';
    document.getElementById('recipientName').value = properties['Recipient Name'] || '';
    applyRadio('sass', properties['Sassiness and/or Sarcasm']);
    applyColors(properties['Favorite Colors']);
    document.getElementById('avoidColors').value = properties['Colors to Avoid, If Possible'] || '';
    document.getElementById('hopeItems').value = properties['Fun Items Hoped For'] || '';
    document.getElementById('spoilItems').value = properties['Items Preferred Not to Receive'] || properties['Items That Would Spoil the Fun'] || '';
    document.getElementById('mustNotInclude').value = properties['Must Not Include'] || '';
    applyRadio('metalPreference', properties['Gold or Silver Preference']);
    document.getElementById('aboutYouNotes').value = properties['About You'] || '';
    applyRadio('repeatCustomer', properties['Previous Customer']);
    document.getElementById('previousOrderNumber').value = properties['Previous Order Number'] || '';
    const hasVideo = properties['Feature Video'] === 'Yes';
    document.getElementById(hasVideo ? 'videoYes' : 'videoNo').checked = true;
    if (hasVideo) {
      const choice = inferVideoChoice(properties);
      document.getElementById('videoName').value = choice;
      if (choice === 'nickname') document.getElementById('videoNickname').value = properties['Video Identification'] || '';
      document.getElementById('videoConsent').checked = properties['Video Consent'] === 'Confirmed';
    }
    SH.state.currentStep = 1;
    syncTier();
    updateVideo();
    updateRepeat();
    updateQuiz();
    document.getElementById('editCustomizationBanner').hidden = false;
    document.getElementById('addConfiguredBoxButton').textContent = 'Update My Customization';
    return true;
  };

  const cancelEdit = () => {
    SH.state.activeEdit = null;
    try { sessionStorage.removeItem(SH.keys.edit); } catch (_) {}
    clearDraft();
    const banner = document.getElementById('editCustomizationBanner');
    if (banner) banner.hidden = true;
    const button = document.getElementById('addConfiguredBoxButton');
    if (button) button.textContent = 'Add My Customized Box to Cart';
    window.location.hash = 'shop';
  };

  const compact = (properties) => Object.fromEntries(Object.entries(properties).filter(([, item]) =>
    item !== null && item !== undefined && String(item).trim() !== ''
  ));

  SH.quiz = {
    extraItems() {
      return (SH.config.addons || []).map(addon => {
        const quantity = Number(value(addon.key) || 0);
        if (!Number.isInteger(quantity) || quantity < 0 || quantity > addon.max) throw new Error(`${addon.label}: choose 0–${addon.max}.`);
        if (quantity && (!addon.variantId || !addon.available)) throw new Error(`${addon.label} is currently unavailable.`);
        return { ...addon, quantity, price: Number(addon.priceCents) / 100 };
      }).filter(addon => addon.quantity > 0);
    },
    value,
    selectedRadio,
    checkedValues,
    videoIdentification,
    setTier,
    syncTier,
    updateQuiz,
    restoreFromProperties,
    clearDraft,
    buildBoxProperties(video, customizationId) {
      const tier = SH.state.selectedTier;
      return compact({
        '_Customization ID': customizationId,
        'Mystery Charms': String(tier.balls),
        'Guaranteed Honey Drops': String(tier.honey),
        'Box For': selectedRadio('forWho'),
        'Customer Name': value('customerName'),
        'Recipient Name': value('recipientName') || value('customerName'),
        'Sassiness and/or Sarcasm': selectedRadio('sass'),
        'Favorite Colors': checkedValues('colors').join(', ') || 'Surprise me',
        'Colors to Avoid, If Possible': value('avoidColors'),
        'Fun Items Hoped For': value('hopeItems'),
        'Items Preferred Not to Receive': value('spoilItems'),
        'Must Not Include': value('mustNotInclude'),
        'Gold or Silver Preference': selectedRadio('metalPreference') || 'Surprise me',
        'About You': value('aboutYouNotes'),
        'Previous Customer': selectedRadio('repeatCustomer') || 'No, this is my first order',
        'Previous Order Number': value('previousOrderNumber'),
        'Feature Video': video ? 'Yes' : 'No',
        'Video Identification Choice': video ? (document.getElementById('videoName')?.value || 'customer') : '',
        'Video Identification': video ? videoIdentification() : '',
        'Video Consent': video && document.getElementById('videoConsent')?.checked ? 'Confirmed' : '',
        'Video Consent Timestamp': video && document.getElementById('videoConsent')?.checked ? new Date().toISOString() : '',
        'Video Consent Version': video && document.getElementById('videoConsent')?.checked ? SH.consentVersion : ''
      });
    },
    buildVideoProperties(customizationId) {
      const tier = SH.state.selectedTier;
      return compact({
        '_Customization ID': customizationId,
        'For Mystery Box': `${tier.balls} Mystery Charms`,
        'Recipient Name': value('recipientName') || value('customerName'),
        'Video Identification': videoIdentification(),
        'Consent': 'Confirmed',
        'Consent Timestamp': new Date().toISOString(),
        'Consent Version': SH.consentVersion
      });
    }
  };

  const initializeCounters = () => {
    document.querySelectorAll('[maxlength][data-character-count]').forEach((control) => {
      const target = document.getElementById(control.dataset.characterCount);
      if (!target) return;
      const update = () => { target.textContent = `${control.value.length}/${control.maxLength}`; };
      control.addEventListener('input', update);
      update();
    });
  };

  const initialize = () => {
    if (!document.getElementById('quizForm')) return;
    const extrasPanel = document.createElement('div');
    extrasPanel.className = 'field-grid';
    extrasPanel.innerHTML = (SH.config.addons || []).map(addon => `<div class="field"><label for="${SH.escapeHtml(addon.key)}">${SH.escapeHtml(addon.label)} — ${SH.formatMoney(Number(addon.priceCents) / 100)}</label><select id="${SH.escapeHtml(addon.key)}" ${addon.available ? '' : 'disabled'}>${Array.from({length: addon.max + 1}, (_, n) => `<option value="${n}">${n}</option>`).join('')}</select><span class="micro">${SH.escapeHtml(addon.note)}</span></div>`).join('');
    document.querySelector('.quiz-step[data-step="9"]')?.append(extrasPanel);
    renderColors();
    updateVideo();
    updateRepeat();
    syncTier();

    document.addEventListener('click', (event) => {
      const tierButton = event.target.closest('[data-tier-choice]');
      if (tierButton && !tierButton.disabled) start(tierButton.dataset.tierChoice);
      const moveButton = event.target.closest('[data-quiz-move]');
      if (moveButton) move(Number(moveButton.dataset.quizMove) || 0);
    });
    document.getElementById('cancelCustomizationEdit')?.addEventListener('click', cancelEdit);
    document.querySelectorAll('input[name="video"]').forEach((input) => input.addEventListener('change', updateVideo));
    document.querySelectorAll('input[name="repeatCustomer"]').forEach((input) => input.addEventListener('change', updateRepeat));
    document.getElementById('videoName')?.addEventListener('change', updateVideoIdentification);
    const form = document.getElementById('quizForm');
    form.addEventListener('input', saveDraft);
    form.addEventListener('change', saveDraft);
    initializeCounters();

    window.setTimeout(() => {
      if (!SH.state.activeEdit) restoreDraft();
      updateVideo();
      updateRepeat();
      syncTier();
      if (window.location.hash === '#customize') updateQuiz();
    }, 0);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
